import PageTabs from './PageTabs';

const TABS = [
    { href: '/payments', icon: 'fa-clock-rotate-left', label: 'PAYMENTS_TAB_HISTORY', exact: true, flag: null },
    { href: '/payments/scheduled', icon: 'fa-calendar-days', label: 'PAYMENTS_TAB_SCHEDULED', exact: false, flag: null },
] as const;

export default function PaymentsNav() {
    return <PageTabs tabs={TABS} />;
}
